import { VStack, Text } from '@chakra-ui/react';
import MfaRecoveryCode from '../../components/client/account/MfaRecoveryCode';

function MfaRecoveryCodePage() {
  return (
    <VStack mb={6} alignItems="flex-start">
      <Text textStyle="heading2">Account recovery</Text>
      <MfaRecoveryCode />
    </VStack>
  );
}

export default MfaRecoveryCodePage;
